import React from 'react'
import { Subscriber } from 'react-broadcast'

const Server = ({ render }) => (
  <Subscriber channel="server">{render}</Subscriber>
)

export default Server



// WEBPACK FOOTER //
// ./src/components/Server/index.js